import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentComponent } from './content.component';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { DYNAMIC_COMPONENT } from 'src/app/shared/dynamic-component-loader/dynamic-component.manifest';
import { PanelsModule } from 'src/app/shared/components/panels/panels.module';
const routes: Routes = [{path: "", component: ContentComponent}];

@NgModule({
  declarations: [
    ContentComponent
  ],
  exports: [
    ContentComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes),
    PanelsModule
  ],
  providers: [
    {provide: DYNAMIC_COMPONENT, useValue: ContentComponent},
  ],
})
export class ContentModule { }
